'use strict';

Object.defineProperty(exports, '__esModule', { value: true });

var react = require('react');
var PropTypes = require('@userzoomlibraries/toolkit-js-utils/prop-types');
var isBoolean = require('@userzoomlibraries/toolkit-js-utils/is-boolean');
var isNull = require('@userzoomlibraries/toolkit-js-utils/is-null');
var isNativeTabbable = require('./is-native-tabbable.js');
var supportsDisabledAttribute = require('./supports-disabled-attribute.js');
var useRole = require('./use-role.js');

function _interopDefaultCompat (e) { return e && typeof e === 'object' && 'default' in e ? e : { 'default': e }; }

var PropTypes__default = /*#__PURE__*/_interopDefaultCompat(PropTypes);
var isBoolean__default = /*#__PURE__*/_interopDefaultCompat(isBoolean);
var isNull__default = /*#__PURE__*/_interopDefaultCompat(isNull);

var _excluded = ["disabled", "focusable"];

function _slicedToArray(arr, i) { return _arrayWithHoles(arr) || _iterableToArrayLimit(arr, i) || _unsupportedIterableToArray(arr, i) || _nonIterableRest(); }

function _nonIterableRest() { throw new TypeError("Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); }

function _unsupportedIterableToArray(o, minLen) { if (!o) return; if (typeof o === "string") return _arrayLikeToArray(o, minLen); var n = Object.prototype.toString.call(o).slice(8, -1); if (n === "Object" && o.constructor) n = o.constructor.name; if (n === "Map" || n === "Set") return Array.from(o); if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _arrayLikeToArray(o, minLen); }

function _arrayLikeToArray(arr, len) { if (len == null || len > arr.length) len = arr.length; for (var i = 0, arr2 = new Array(len); i < len; i++) { arr2[i] = arr[i]; } return arr2; }

function _iterableToArrayLimit(arr, i) { var _i = arr == null ? null : typeof Symbol !== "undefined" && arr[Symbol.iterator] || arr["@@iterator"]; if (_i == null) return; var _arr = []; var _n = true; var _d = false; var _s, _e; try { for (_i = _i.call(arr); !(_n = (_s = _i.next()).done); _n = true) { _arr.push(_s.value); if (i && _arr.length === i) break; } } catch (err) { _d = true; _e = err; } finally { try { if (!_n && _i["return"] != null) _i["return"](); } finally { if (_d) throw _e; } } return _arr; }

function _arrayWithHoles(arr) { if (Array.isArray(arr)) return arr; }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); if (enumerableOnly) { symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; }); } keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i] != null ? arguments[i] : {}; if (i % 2) { ownKeys(Object(source), true).forEach(function (key) { _defineProperty(target, key, source[key]); }); } else if (Object.getOwnPropertyDescriptors) { Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)); } else { ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } } return target; }

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

var focusablePropTypes = _objectSpread(_objectSpread({}, useRole.rolePropTypes), {}, {
  disabled: PropTypes__default["default"].boolWithDescription('Flag to enable/disable the component.'),
  focusable: PropTypes__default["default"].boolWithDescription('Flag to enable/disable the focus behaviour.')
});

var focusableDefaultProps = _objectSpread(_objectSpread({}, useRole.roleDefaultProps), {}, {
  disabled: false,
  focusable: null
});

var useFocusable = function useFocusable(element) {
  var _ref = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {},
      _ref$disabled = _ref.disabled,
      disabled = _ref$disabled === void 0 ? focusableDefaultProps.disabled : _ref$disabled,
      _ref$focusable = _ref.focusable,
      focusable = _ref$focusable === void 0 ? focusableDefaultProps.focusable : _ref$focusable,
      otherProps = _objectWithoutProperties(_ref, _excluded);

  var _useState = react.useState(0),
      _useState2 = _slicedToArray(_useState, 2),
      tabIndexState = _useState2[0],
      setTabIndexState = _useState2[1];

  var _useState3 = react.useState(false),
      _useState4 = _slicedToArray(_useState3, 2),
      isCompletelyDisabled = _useState4[0],
      setIsCompletelyDisabled = _useState4[1];

  var _useState5 = react.useState(true),
      _useState6 = _slicedToArray(_useState5, 2),
      supportsNativeTabbable = _useState6[0],
      setSupportsNativeTabbable = _useState6[1];

  var _useState7 = react.useState(true),
      _useState8 = _slicedToArray(_useState7, 2),
      supportsDisabled = _useState8[0],
      setSupportsDisabled = _useState8[1];

  var rolableProps = useRole["default"](otherProps);
  var focusableNode = element;
  react.useEffect(function () {
    if (focusableNode) {
      if (!isNativeTabbable(focusableNode)) {
        setSupportsNativeTabbable(false);
      }

      if (!supportsDisabledAttribute(focusableNode)) {
        setSupportsDisabled(false);
      }
    }
  }, [focusableNode]);
  react.useEffect(function () {
    setIsCompletelyDisabled(disabled && !focusable);
  }, [disabled, focusable]);
  react.useEffect(function () {
    if (isCompletelyDisabled) {
      if (supportsNativeTabbable && !supportsDisabled) {
        // If the element is natively tabbable but it doesn't support the disabled attribute, we set the tabindex to -1.
        setTabIndexState(-1);
      } else {
        // Elements that support the disabled attribute and are disabled, don't need a tabIndex.
        setTabIndexState(null);
      }
    } else if (supportsNativeTabbable) {
      if (isBoolean__default["default"](focusable) && !focusable) {
        // If the element is enabled and is natively tabbable, but focusable is set to false, we set the tabindex to -1.
        setTabIndexState(-1);
      } else {
        // If the element is enabled and is natively tabbable and focusable is set to true or focusable is not set, we set the tabindex to the passed by props or 0 (fallback).
        setTabIndexState(0);
      }
    } else if (isBoolean__default["default"](focusable) && !focusable || isNull__default["default"](focusable)) {
      // If the element is enabled and is not natively tabbable and focusable is set to false or it's set to null, we set the tabindex to -1.
      setTabIndexState(-1);
    } else {
      // If the element is enabled and is natively tabbable and focusable is set to true, we set the tabindex to the passed by props or 0 (fallback).
      setTabIndexState(0);
    }
  }, [isCompletelyDisabled, supportsNativeTabbable, supportsDisabled, focusable]);

  var disabledProp = function () {
    // In case that the element doesn't have support for disabled attribute, we don't have to send a value.
    if (!supportsDisabled) {
      return null;
    } // Otherwise, we return if it's completely disabled.


    return isCompletelyDisabled;
  }();

  return _objectSpread(_objectSpread({}, rolableProps), {}, {
    tabIndex: tabIndexState,
    disabled: disabledProp,
    'aria-disabled': disabled
  });
};

useFocusable.HOOK_ID = 'Gearz.ReactHooks.useFocusable';
useFocusable.returnType = PropTypes__default["default"].shapeWithDescription(_objectSpread(_objectSpread({}, useRole.rolePropTypes), {}, {
  tabIndex: PropTypes__default["default"].stringWithDescription('Tab index for the component.'),
  disabled: PropTypes__default["default"].boolWithDescription('Flag to enable/disable the component.'),
  'aria-disabled': PropTypes__default["default"].boolWithDescription('Aria attribute for disabled state.')
}), 'Object with role attribute.');
useFocusable.parameterTypes = {
  element: PropTypes__default["default"].instanceOfWithDescription(HTMLElement, 'Reference of the focusable element.').isRequired,
  props: PropTypes__default["default"].objectWithDescription('Props of the component.').isRequired
};
useFocusable.defaultParameters = {};

exports["default"] = useFocusable;
exports.focusableDefaultProps = focusableDefaultProps;
exports.focusablePropTypes = focusablePropTypes;
exports.useFocusable = useFocusable;
